import React from 'react'
import ReactTooltip, { TooltipProps } from 'react-tooltip'
import styled from 'particles/themes/styled'
import { theme } from 'theme'

const BasePartiTooltip = styled(ReactTooltip)`
    padding: ${({ theme }) => theme.spacing[300]};
    box-shadow: 0px 0px 12px 0px #0000001f;
    pointer-events: auto !important;
    border-radius: 4px;
`

export const PartiTooltip: React.FC<TooltipProps> = ({
    backgroundColor = theme.newColors.neutral50,
    place = 'top',
    ...props
}) => {
    return (
        <BasePartiTooltip
            {...props}
            html
            type="light"
            place={place}
            borderColor="transparent"
            effect="solid"
            delayShow={0}
            multiline={true}
            backgroundColor={backgroundColor}
        />
    )
}

const Tooltips: React.FC = () => {
    return (
        <>
            <PartiTooltip id="partiTooltip" globalEventOff="click" border={true} />
        </>
    )
}

/**
 * @deprecated Please use particles/Tooltip
 */
// FIXME: remove ThemeProvider under src/components/Submissions/Review/Submissions/ProgressBlock/PopupUserInfo.tsx after migrating this component
export default Tooltips
